const faqItems = [
  {
    question: 'Is my financial data safe?',
    answer:
      "Absolutely. Debt Chisel never asks for bank logins or account credentials. You manually enter your debt info, and everything is encrypted and stored securely. We don't sell your data to third parties. Ever.",
  },
  {
    question: 'Why not just use a spreadsheet?',
    answer:
      'Spreadsheets work for simple scenarios, but break down with variable income and complex portfolios. Debt Chisel handles the math, optimizes your strategy, and tracks your progress month-to-month \u2014 automatically.',
  },
  {
    question: 'How is this different from Mint or YNAB?',
    answer:
      "Mint and YNAB are budgeting tools that track all spending. Debt Chisel is laser-focused on debt elimination. We build exact payoff plans with variable-income scenarios and AI optimization. No bank sync required, so it's more private and less invasive.",
  },
  {
    question: 'What exactly does the AI hybrid strategy do?',
    answer:
      "It analyzes your full debt portfolio and creates a custom payment order that balances psychological wins (paying off small debts for motivation) with mathematical efficiency (targeting high-interest debts). It's smarter than pure avalanche or snowball alone.",
  },
  {
    question: 'Can I cancel anytime?',
    answer:
      'Yes. Pro subscriptions are month-to-month, or annual if you prefer. Cancel anytime from your account settings. No fees, no questions asked.',
  },
  {
    question: 'Do I need a credit card for the free tier?',
    answer:
      "Nope. The free tier is truly free, forever. No credit card required to sign up. Upgrade to Pro whenever you're ready.",
  },
  {
    question: 'What happens if I miss a payment one month?',
    answer:
      "Your plan doesn't break. During your monthly check-in, enter what you actually paid \u2014 even if it's $0. Pro users get revised projections showing exactly how it affects your debt-free date. It's judgment-free accountability.",
  },
  {
    question: 'Can I share my account with family?',
    answer:
      "Debt Chisel is currently single-user only. We're not planning shared accounts right now, but we're always listening \u2014 let us know if it's something you'd use.",
  },
];

const appSchema = {
  '@context': 'https://schema.org',
  '@type': 'SoftwareApplication',
  name: 'Debt Chisel',
  applicationCategory: 'FinanceApplication',
  operatingSystem: 'Web',
  offers: [
    {
      '@type': 'Offer',
      price: '0',
      priceCurrency: 'USD',
      name: 'Free',
      description: 'Up to 5 debts, basic features',
    },
    {
      '@type': 'Offer',
      price: '9.99',
      priceCurrency: 'USD',
      name: 'Pro',
      description: 'Unlimited debts, AI-powered optimization',
    },
  ],
  description:
    'Smart debt payoff plans optimized for variable income. Create personalized strategies with AI-powered hybrid optimization. Free for up to 5 debts.',
  url: 'https://app.debtchisel.com',
  featureList: [
    'Variable income budget scenarios',
    'AI-powered hybrid debt strategy',
    'Exact monthly payment schedules',
    'Debt payoff timeline & roadmap',
    'Monthly check-ins with progress tracking',
    'CSV & Excel debt import',
  ],
};

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqItems.map((item) => ({
    '@type': 'Question',
    name: item.question,
    acceptedAnswer: {
      '@type': 'Answer',
      text: item.answer,
    },
  })),
};

export default function StructuredData() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(appSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />
    </>
  );
}
